import jbfFeed from '../horizontal/jbfFeed'
import selectFeed from '../horizontal/selectFeed'
import jumboFeed from '../horizontal/jumboFeed'
import petFood from '../horizontal/petFood'
import rawMaterial from '../horizontal/rawMaterial'
import qualitySystem from '../horizontal/qualitySystem'
import information from '../horizontal/information'
import aboutUs from '../horizontal/aboutUs'


export default [...jbfFeed, ...selectFeed, ...jumboFeed, ...petFood, ...rawMaterial, ...qualitySystem, ...information, ...aboutUs]

